import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import {
  PoMenuItem,
  PoMenuModule,
  PoPageModule,
  PoToolbarModule,
  PoButtonModule,
} from '@po-ui/ng-components';
import { AuthService } from './services/auth/auth.service';
import { PartnerService } from './services/api/partner.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterModule,
    PoToolbarModule,
    PoMenuModule,
    PoPageModule,
    PoButtonModule,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true
})
export class AppComponent implements OnInit {
  isAuth: boolean = false;
  hasSelectedPartner: boolean = false;
  private subscription: Subscription = new Subscription();
  
  constructor(
    private authService: AuthService,
    private partnerService: PartnerService,
    private router: Router,
  ) {}


  async ngOnInit() {
    setTimeout(() => {
      if (!this.router.url.includes('/auth-callback')) {
        this.authService.checkAuth();
      }
    }, 500);

    this.subscription.add(
      this.authService.isAuthenticated$.subscribe(isAuthenticated => {
        this.isAuth = isAuthenticated;

        if (
          isAuthenticated &&
          !this.partnerService.hasSelectedPartner() &&
          !this.router.url.includes('/selecionar-parceiro')
        ) {
          this.router.navigate(['/selecionar-parceiro']);
        }
      })
    );


    this.subscription.add(
      this.partnerService.currentPartnerSelected$.subscribe(partner => {
        this.hasSelectedPartner = !!partner;
        
        if (
          this.isAuth &&
          this.hasSelectedPartner && 
          (this.router.url.includes('/selecionar-parceiro') || this.router.url.includes('/auth-callback'))
        ) {
          this.router.navigate(['/']);
        }
      })
    );

    this.hasSelectedPartner = this.partnerService.hasSelectedPartner()
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  readonly logoPath = 'assets/images/brand.png';

  readonly menus: PoMenuItem[] = [
    {
      label: 'Início',
      shortLabel: 'Início',
      link: '/',
      icon: 'an an-house'
    },
    {
      label: 'Produtos cadastrados',
      shortLabel: 'Produtos cadastrados',
      link: '/produtos-cadastrados',
      icon: 'an an-cardholder'
    },
    {
      label: 'Contratos ativos',
      shortLabel: 'Contratos ativos',
      link: '/contratos-ativos',
      icon: 'an an-file'
    },
    {
      label: 'Finanças',
      shortLabel: 'Finanças',
      icon: 'an an-currency-circle-dollar',
      subItems: [
        { label: 'Pagamentos', link: '/pagamentos' },
        { label: 'Pagamentos em atraso', link: '/pagamentos-em-atraso' },
        { label: 'Faturamento', link: '/faturamento' },
      ]
    },
    {
      label: 'Novas vendas',
      shortLabel: 'Novas vendas',
      link: '/novas-vendas',
      icon: 'an an-cash-register'
    },
    {
      label: 'Gestão de licenças',
      shortLabel: 'Gestão de licenças',
      icon: 'an an-folder-lock',
      subItems: [
        { label: 'Bloqueios', link: '/bloqueios' },
        { label: 'Desbloqueios', link: '/desbloqueios' },
      ]
    },
    {
      label: 'Cancelamentos',
      shortLabel: 'Cancelamentos',
      link: '/cancelanentos',
      icon: 'an an-tray-arrow-down'
    },
    {
      label: 'Documentação',
      shortLabel: 'Documentação',
      link: '/documentacao',
      icon: 'an an-book-open-text'
    }
  ];
}
